// extracted by mini-css-extract-plugin
module.exports = {"headerMenu":"index-headerMenu-8_HJZ","header":"index-header-1ncQ3","logo":"index-logo-rq92Q","coursemenu":"index-coursemenu-1_edy","coursemenuGroup":"index-coursemenuGroup-cjYaa"};